var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "custom-button" }, [
    _c(
      "a",
      {
        class: [
          "btn",
          _vm.type,
          _vm.size,
          _vm.active,
          _vm.content,
          _vm.useContext,
        ],
        attrs: { tabindex: _vm.tabIndex },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.onEnter.apply(null, arguments)
          },
          click: _vm.onClick,
        },
      },
      [
        _vm.content === "icon-with-label" ? _vm._t("icon") : _vm._e(),
        _vm._v(" "),
        _c("paragraph", {
          staticClass: "button-text",
          attrs: { type: "p", variation: _vm.size },
          domProps: { innerHTML: _vm._s(_vm.text) },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }